module.exports = __webpack_public_path__ + "static/media/portfolio-04.5bf9f8a2.jpg";